module.exports = __webpack_public_path__ + "static/media/animals.e3d6911b.png";